<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on }">
      <!-- <v-btn class="success" v-on="on"> -->
      <v-icon left v-on="on" small title="Edit" color="primary">edit</v-icon>
      <!-- </v-btn> -->
    </template>
    <v-card>
      <v-card-title>
        <v-icon left>edit_square</v-icon>
        <span class="headline">Edit User</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon large color="error">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container grid-list-md class="py-0">
        <v-card-text class="py-0">
          <v-form ref="edit_user_form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="newUser.name"
              label="Name *"
              :rules="[(v) => !!v || 'Name is required']"
            ></v-text-field>
            <v-text-field
              v-model="newUser.email"
              label="Email *"
              :rules="[
                (v) => !!v || 'Email is required',
                (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
              ]"
            ></v-text-field>
            <v-text-field
              name="new-password"
              v-model="newUser.password"
              label="Password"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              :rules="[
                (v) =>
                  /(?=.{6,}).*$/.test(v) ||
                  'Password must be minimum 6 characters',
              ]"
            ></v-text-field>

            <v-autocomplete
              v-model="newUser.admin_type"
              :items="userTypes"
              label="User Type"
              item-text="name"
              item-value="id"
              persistent-hint
              :rules="[(v) => !!v || 'User Type is required']"
            />
            <label
              aria-hidden="true"
              class="v-label v-label--active theme--light"
              style="position: absolute; font-size: 12px"
            >
              User Status
            </label>
            <v-switch
              v-model="newUser.active"
              color="green"
              :label="newUser.active ? 'Active' : 'Inactive'"
              @change="changeStatus"
            ></v-switch>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            :loading="loading"
            :disabled="loading || !valid"
            @click="save"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  export default {
    props: ["userDetails", "userTypes"],
    data() {
      return {
        dialog: false,
        loading: false,
        valid: false,
        newUser: null,
        showPassword: false,
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    created() {
      this.initialize();
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      initialize() {
        this.newUser = { ...this.userDetails };
        this.newUser.admin_type = this.userDetails.role.id;
        delete this.newUser.password;
      },
      close() {
        this.dialog = false;
      },
      async save() {
        await this.$refs.edit_user_form.validate();
        if (this.valid) {
          try {
            this.loading = true;
            const { data } = await api.storeData(
              this.auth.token,
              "official-user",
              this.newUser
            );

            if (data.error) {
              this.$emit("result", [data.errorMsg, "error"]);
            } else {
              this.$emit("result", [
                "User data updated successfully",
                "success",
              ]);
              this.close();
            }

            // this.loading = false;
          } catch (error) {
            //
          }
          this.loading = false;
        }
      },
      changeStatus() {
        this.newUser.active = this.newUser.active ? 1 : 0;
      },
    },
  };
</script>
